import React from 'react';
import { useFormContext } from 'react-hook-form';

import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';
import { TransactionSigningValues } from 'common/components/Modules/TransactionEdit/types';

import {
  CreateInvoiceNote,
  CreateInvoiceNoteVariables,
} from 'ap/paymentCycle/view/TransactionModal/TransactionDetail/ActionMenu/__generated__/CreateInvoiceNote';

import ADD_NEW_NOTE from 'common/graphql/CreateInvoiceSigningNote.graphql';

type TransactionNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  invoiceId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const TransactionNotesSection: React.FC<
  TransactionNotesSectionProps
> = ({ invoiceId, data, listRefreshRequest, loading }) => {
  // This ensures the dirty state is picked up if inside a FormProvider
  useFormContext<TransactionSigningValues>();

  return (
    <GenericNotesSection<
      TransactionSigningValues,
      CreateInvoiceNote,
      CreateInvoiceNoteVariables
    >
      entityId={invoiceId}
      data={data}
      loading={loading}
      mutationDocument={ADD_NEW_NOTE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
